import * as React from 'react'
import { AppConnected } from './AppConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const AppExamples = () => {
  return (
    <div className="AppExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <AppConnected />
      </Provider>
    </div>
  )
}
